export enum AssetTypeTag {
    CURRENT_HEAT_MAP = 'CURRENT_HEAT_MAP',
    VOLTAGE_HEAT_MAP= 'VOLTAGE_HEAT_MAP',
    VACUUM_HEAT_MAP = 'VACUUM_HEAT_MAP',
    RESISTANCE_HEAT_MAP = 'RESISTANCE_HEAT_MAP',
    FOD= 'FOD',
    SENSOR_STATUS = 'SENSOR_STATUS',
    GRAPHICS = 'GRAPHICS'
}
